var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardContent, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useRetrieveSeason, useUpdateSeason } from "../api/SeasonApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
import { SeasonForm } from "./SeasonForm";
export var UpdateSeason = function () {
    var id = useNumericParams().id;
    var navigate = useNavigate();
    var _a = useRetrieveSeason({ id: id }), season = _a.data, isLoading = _a.isLoading, error = _a.error;
    var mutation = useUpdateSeason({
        onMutate: function () { },
        onSuccess: function (data) {
            var updated = data.data;
            navigate("/seasons/".concat(updated.id, "/"));
        },
        onError: function () { },
    });
    if (!id) {
        return _jsx(ErrorView, { error: new Error("Missing season id") });
    }
    if (isLoading) {
        return _jsx(Loading, {});
    }
    if (error || !season) {
        return _jsx(ErrorView, { error: error || new Error("Failed to load season") });
    }
    var handleSubmit = function (form) {
        mutation.mutate(__assign(__assign(__assign({}, season), form), { id: season.id }));
    };
    return (_jsx(Card, { children: _jsxs(CardContent, { children: [_jsx(ErrorSnackbar, { open: mutation.isError, message: "Failed to update season. Please try again.", onClose: function () { } }), _jsx(Typography, { variant: "h6", gutterBottom: true, children: "Update Season" }), _jsx(SeasonForm, { onSubmit: handleSubmit, season: season })] }) }));
};
